import { commonFilter } from './filter';

export default {
  pageName: 'region',
  pageId: '20007',
  pagePath: '/opinion/Stats/Region',
  common: {
    source: 2,
    typeId: 'opinion_pc_v2',
  },
  button: {
    ...commonFilter,
  },
};
